module.exports = __webpack_public_path__ + "k-start.wav?136a270a623c7a83349c92e9cb0eec3a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-start.wav
// module id = 16
// module chunks = 0